import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { t as translate } from 'react-multi-lang'

import { BackgroundContainer, MainContainer, InfoContainer, FormContainer, FooterContainer, ImgLogo, Form, InputDiv, InputStyle, CheckboxDiv, CheckboxText, SignButton, OrangeText, InfoItems, InfoNumber, InfoText } from './styled'

import logoMark from '../../../assets/images/MM-Logomark-2C.png'
import api from '../../../services/api'
import useAuth from '../../../hooks/useAuth'
import { toast } from 'react-toastify'
import axios from 'axios'
import ReactGA from 'react-ga4'

const Register = () => {
  ReactGA.initialize('G-FHPNEK8D8D')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [coupon, setCoupon] = useState(false)
  const [company, setCompany] = useState('')
  const [terms, setTerms] = useState(false)
  const [buttonDisabled, setButtonDisabled] = useState(false)

  const { signIn } = useAuth()

  async function getId (uniqueId: string) {
    const { data: subscription }: any = await api.postMethod('getSubscriptionUniqueId', { uniqueId })
    console.log(subscription)
    return subscription
  }

  async function handleToStripe (subscriptionId: string) {
    const userId = localStorage.getItem('userId')
    const successUrl = `${window.location.origin}/success-payment?userId=${userId}&subscription_id=${subscriptionId}&payment_mode=subscription`
    const cancelUrl = `${window.location.origin}/plans`
    const { data: info }: any = await axios.get('https://geolocation-db.com/json/')
    const { data }: any = await api.postMethod('create-checkout-session', {
      subscription_id: subscriptionId,
      successUrl,
      cancelUrl,
      email,
      ip: info.IPv4
    })
    window.location.href = data.url
  }

  async function handleSubmit (e: any) {
    e.preventDefault()
    setButtonDisabled(true)

    if (!firstName && !lastName && !company && !email && !password) {
      toast.error('All fields are required')
      setButtonDisabled(false)
      return
    }

    if (!firstName) {
      toast.error('First Name field is required')
      setButtonDisabled(false)
      return
    }

    if (!lastName) {
      toast.error('Last Name field is required')
      setButtonDisabled(false)
      return
    }

    if (!company) {
      toast.error('Company field is required')
      setButtonDisabled(false)
      return
    }

    if (!email) {
      toast.error('Email field is required')
      setButtonDisabled(false)
      return
    }

    if (!password) {
      toast.error('Password field is required')
      setButtonDisabled(false)
      return
    }

    if (!terms) {
      toast.error('Must agree with Terms to proceed.')
      setButtonDisabled(false)
      return
    }

    const { data }: any = await api.postMethod('v4/register', {
      name: firstName,
      last_name: lastName,
      email,
      company,
      password,
      is_super_user: 0,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      coupon
    })

    if (data.success) {
      ReactGA.event({
        category: 'User',
        action: 'sign-up',
        label: 'Account created successfully',
        value: 75
      })
      localStorage.setItem('userId', data.data.user_id)
      localStorage.setItem('accessToken', data.data.token)
      localStorage.setItem('userType', data.data.user_type)
      localStorage.setItem('push_status', data.data.push_status)
      localStorage.setItem('username', data.data.name)
      localStorage.setItem('active_profile_id', data.data.sub_profile_id)
      localStorage.setItem('active_profile_image', data.data.picture)
      localStorage.setItem('active_profile_name', data.data.name)
      signIn(email, password)
      toast.success(data.message)
      if (coupon) {
        const teste = await getId('One year subscription – full price.')
        if (teste?.id) {
          handleToStripe(teste.id)
        }
      } else {
        const teste = await getId('Basic-plan60492b75eacc3')
        if (teste?.id) {
          handleToStripe(teste.id)
        }
      }
    } else {
      toast.error(data.error_messages)
    }
    setButtonDisabled(false)
  }

  return (
    <BackgroundContainer>
      <MainContainer>
        <InfoContainer>
          <InfoItems>
            <InfoNumber>1</InfoNumber>
            <InfoText>
              Free 30 day trial. <br/>Cancel anytime. <br/> $199 / month after trial.
            </InfoText>
          </InfoItems>
          <InfoItems>
            <InfoNumber>2</InfoNumber>
            <InfoText>
              Unlimited access to 500+, tactical, best practice, videos, delivered by manufacturing experts.
            </InfoText>
          </InfoItems>
          <InfoItems>
            <InfoNumber>3</InfoNumber>
            <InfoText>
              Ability to sign-up 4 additional staff and share videos amongst your entire team.
            </InfoText>
          </InfoItems>
        </InfoContainer>
        <FormContainer>
          <Form onSubmit={handleSubmit}>
            <Link to="/login">
              <ImgLogo src={logoMark} />
            </Link>
            <InputDiv>
              <InputStyle
                type="text"
                onChange={(text: React.ChangeEvent<HTMLInputElement>) => setFirstName(text.target.value)}
                id="firstName"
                name="firstName"
                placeholder="First Name"
                value={firstName}
              />
            </InputDiv>
            <InputDiv>
              <InputStyle
                type="text"
                onChange={(text: React.ChangeEvent<HTMLInputElement>) => setLastName(text.target.value)}
                id="lastName"
                name="lastName"
                placeholder="Last Name"
                value={lastName}
              />
            </InputDiv>
            <InputDiv>
              <InputStyle
                type="text"
                onChange={(text: React.ChangeEvent<HTMLInputElement>) => setCompany(text.target.value)}
                id="company"
                name="company"
                placeholder="Company"
                value={company}
              />
            </InputDiv>
            <InputDiv>
              <InputStyle
                type="email"
                onChange={(text: React.ChangeEvent<HTMLInputElement>) => setEmail(text.target.value)}
                id="email"
                name="email"
                placeholder="E-mail"
                value={email}
              />
            </InputDiv>
            <InputDiv>
              <InputStyle
                type="password"
                onChange={(text: React.ChangeEvent<HTMLInputElement>) => setPassword(text.target.value)}
                id="pwd"
                name="password"
                placeholder="Password"
                value={password}
              />
            </InputDiv>
            <InputDiv>
            <CheckboxDiv>
              <input
                type="checkbox"
                id="coupon"
                name="coupon"
                onChange={(text: React.ChangeEvent<HTMLInputElement>) => setCoupon(!coupon)}
                value={+coupon}
              />
              <CheckboxText>
              Use a coupon
              </CheckboxText>
            </CheckboxDiv>

            <CheckboxDiv>
              <input
                type="checkbox"
                id="chkTerm"
                name="agreeTerms"
                onChange={(text: React.ChangeEvent<HTMLInputElement>) => setTerms(!terms)}
                value={+terms}
              />
              <CheckboxText>
                I agree with the <Link to="/page/terms"> <OrangeText>terms</OrangeText></Link>
              </CheckboxText>
            </CheckboxDiv>
            </InputDiv>
            <SignButton
              disabled={buttonDisabled}>
              {
              buttonDisabled
                ? 'Loading...'
                : translate('signup')
              }
            </SignButton>
            <CheckboxText>
              Already have an account? <Link to={'/login'}> < OrangeText> Sign In Now</OrangeText> </Link>
            </CheckboxText>
          </Form>
        </FormContainer>
      </MainContainer>
      <FooterContainer>
        <div>500+ Videos in our growing training library.</div>
        <div>Continuous Improvement - Strategy and Planning - Design and Engineering - Finance and Reporting - Health and Safety.</div>
        <div>Human resources and Recruitment - Internet of things - Smart factories - Additive manufacturing.</div>
        <div>IT and Cyber Security - Logistics - Marketing - Sales - Shop Floor - Supply Chain - Job Descriptions - Global Development - Wellness.</div>
      </FooterContainer>
    </BackgroundContainer>
  )
}

export default Register
